module.exports = __webpack_public_path__ + "static/img/Al_Rocco.a058693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Al_Rocco.jpg
// module id = IXqI
// module chunks = 1